const BollettaIllustration = ({
    color,
    ...rest
}: React.SVGAttributes<SVGSVGElement> & { color?: string }) => {
    return (
        <svg
            width={rest.width || 385}
            height={rest.height || 453}
            viewBox="0 0 385 453"
            fill="none"
            {...rest}>
            <g filter="url(#filter0_d_123_6662)">
                <rect
                    x="54"
                    y="50"
                    width="276.738"
                    height="345"
                    rx="20"
                    fill="white"
                />
            </g>
            <rect
                x="84.4414"
                y="73.9839"
                width="67.3396"
                height="23.984"
                fill="url(#pattern0)"
            />
            <rect
                x="225.578"
                y="109.96"
                width="66.4171"
                height="8.30214"
                rx="4.15107"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="145.013"
                width="66.4171"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="170.842"
                width="66.4171"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="171.152"
                y="170.842"
                width="66.4171"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="171.152"
                y="198.516"
                width="66.4171"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="198.516"
                width="66.4171"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="155.16"
                width="75.6417"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="180.989"
                width="75.6417"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="171.152"
                y="180.989"
                width="75.6417"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="171.152"
                y="208.663"
                width="75.6417"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="326.738"
                width="42.4332"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="336.885"
                width="47.9679"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="159.161"
                y="326.738"
                width="42.4332"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="159.161"
                y="336.885"
                width="47.9679"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="242.182"
                y="326.738"
                width="42.4332"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="242.182"
                y="336.885"
                width="47.9679"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.5"
                x="76.1392"
                y="208.663"
                width="75.6417"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.9"
                x="76.1392"
                y="244.639"
                width="155.896"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.9"
                x="76.1392"
                y="254.786"
                width="142.981"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.6"
                x="76.1392"
                y="264.933"
                width="105.16"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <rect
                opacity="0.6"
                x="76.1392"
                y="275.08"
                width="155.896"
                height="4.6123"
                rx="2.30615"
                fill={color || '#369FFF'}
            />
            <circle cx="272.162" cy="258.937" r="25.3676" fill="#EFEFEF" />
            <path
                d="M291.995 258.937C291.995 262.031 291.271 265.081 289.882 267.845C288.492 270.609 286.476 273.01 283.993 274.855C281.51 276.7 278.63 277.939 275.583 278.473C272.535 279.006 269.406 278.82 266.444 277.928C263.481 277.036 260.769 275.463 258.523 273.336C256.277 271.208 254.56 268.585 253.509 265.676C252.458 262.766 252.102 259.651 252.47 256.58C252.837 253.508 253.919 250.565 255.627 247.986L272.162 258.937H291.995Z"
                fill="#FF2F78"
            />
            <path
                d="M255.114 248.802C256.54 246.404 258.455 244.334 260.734 242.727C263.014 241.12 265.607 240.012 268.344 239.475C271.082 238.938 273.901 238.985 276.619 239.612C279.337 240.238 281.892 241.432 284.118 243.113L272.162 258.937L255.114 248.802Z"
                fill="#9232CD"
            />
            <path
                d="M255.114 248.802C256.54 246.404 258.455 244.334 260.734 242.727C263.014 241.12 265.607 240.012 268.344 239.475C271.082 238.938 273.901 238.985 276.619 239.612C279.337 240.238 281.892 241.432 284.118 243.113L272.162 258.937L255.114 248.802Z"
                fill="#9232CD"
            />
            <path
                d="M255.114 248.802C256.54 246.404 258.455 244.334 260.734 242.727C263.014 241.12 265.607 240.012 268.344 239.475C271.082 238.938 273.901 238.985 276.619 239.612C279.337 240.238 281.892 241.432 284.118 243.113L272.162 258.937L255.114 248.802Z"
                fill="#1976F2"
            />
            <g filter="url(#filter1_i_123_6662)">
                <circle cx="125.03" cy="173.61" r="58.115" fill="white" />
            </g>
            <circle
                cx="125.03"
                cy="173.61"
                r="56.615"
                stroke="#E7E7E7"
                strokeOpacity="0.3"
                strokeWidth="3"
            />
            <path
                d="M91.91 171V161.64H93.288L97.8965 168.595V161.64H99.2745V171H97.8965L93.288 164.038V171H91.91ZM102.909 166.125C102.48 166.125 102.088 166.021 101.732 165.813C101.377 165.601 101.093 165.319 100.881 164.968C100.673 164.613 100.569 164.218 100.569 163.785C100.569 163.36 100.677 162.97 100.894 162.615C101.11 162.26 101.396 161.976 101.752 161.763C102.107 161.551 102.493 161.445 102.909 161.445C103.338 161.445 103.728 161.551 104.079 161.763C104.434 161.971 104.718 162.253 104.93 162.608C105.143 162.959 105.249 163.352 105.249 163.785C105.249 164.218 105.143 164.613 104.93 164.968C104.718 165.319 104.434 165.601 104.079 165.813C103.728 166.021 103.338 166.125 102.909 166.125ZM102.909 164.948C103.117 164.948 103.31 164.896 103.487 164.792C103.665 164.684 103.806 164.541 103.91 164.363C104.018 164.186 104.072 163.993 104.072 163.785C104.072 163.577 104.018 163.384 103.91 163.206C103.806 163.029 103.665 162.888 103.487 162.784C103.31 162.676 103.117 162.621 102.909 162.621C102.701 162.621 102.508 162.676 102.33 162.784C102.157 162.888 102.016 163.029 101.908 163.206C101.799 163.384 101.745 163.577 101.745 163.785C101.745 163.993 101.799 164.186 101.908 164.363C102.016 164.541 102.157 164.684 102.33 164.792C102.504 164.896 102.696 164.948 102.909 164.948ZM110.848 171.195C109.912 171.195 109.114 170.991 108.456 170.584C107.797 170.172 107.292 169.6 106.941 168.868C106.595 168.136 106.421 167.286 106.421 166.32C106.421 165.354 106.595 164.504 106.941 163.772C107.292 163.04 107.797 162.47 108.456 162.062C109.114 161.651 109.912 161.445 110.848 161.445C111.927 161.445 112.819 161.718 113.526 162.264C114.236 162.81 114.73 163.544 115.008 164.468L113.63 164.838C113.448 164.184 113.123 163.67 112.655 163.297C112.191 162.925 111.589 162.738 110.848 162.738C110.185 162.738 109.632 162.888 109.19 163.187C108.748 163.486 108.415 163.904 108.189 164.441C107.968 164.979 107.858 165.605 107.858 166.32C107.853 167.035 107.962 167.661 108.183 168.198C108.408 168.736 108.742 169.154 109.184 169.453C109.63 169.752 110.185 169.901 110.848 169.901C111.589 169.901 112.191 169.715 112.655 169.342C113.123 168.965 113.448 168.452 113.63 167.802L115.008 168.172C114.73 169.095 114.236 169.83 113.526 170.376C112.819 170.922 111.927 171.195 110.848 171.195ZM116.567 171V161.445H117.926V171H116.567ZM120.008 162.829V161.51H121.366V162.829H120.008ZM120.008 171V163.98H121.366V171H120.008ZM126.432 171.195C125.734 171.195 125.121 171.043 124.592 170.74C124.068 170.432 123.658 170.005 123.364 169.459C123.073 168.909 122.928 168.272 122.928 167.548C122.928 166.781 123.071 166.116 123.357 165.553C123.648 164.99 124.051 164.554 124.566 164.246C125.082 163.939 125.682 163.785 126.367 163.785C127.082 163.785 127.691 163.952 128.193 164.286C128.696 164.615 129.071 165.085 129.318 165.696C129.569 166.307 129.669 167.033 129.617 167.873H128.258V167.379C128.25 166.565 128.094 165.962 127.79 165.572C127.491 165.182 127.034 164.987 126.419 164.987C125.738 164.987 125.227 165.202 124.885 165.631C124.542 166.06 124.371 166.68 124.371 167.49C124.371 168.261 124.542 168.859 124.885 169.284C125.227 169.704 125.721 169.914 126.367 169.914C126.791 169.914 127.158 169.819 127.465 169.628C127.777 169.433 128.02 169.156 128.193 168.796L129.526 169.219C129.253 169.847 128.839 170.335 128.284 170.681C127.73 171.024 127.112 171.195 126.432 171.195ZM123.929 167.873V166.814H128.941V167.873H123.929ZM135.812 171V167.548C135.812 167.275 135.788 166.996 135.74 166.71C135.697 166.42 135.61 166.151 135.48 165.904C135.354 165.657 135.175 165.458 134.941 165.306C134.711 165.154 134.41 165.078 134.037 165.078C133.794 165.078 133.565 165.12 133.348 165.202C133.131 165.28 132.941 165.408 132.776 165.585C132.616 165.763 132.488 165.997 132.393 166.287C132.302 166.578 132.256 166.931 132.256 167.347L131.411 167.028C131.411 166.391 131.53 165.83 131.769 165.345C132.007 164.855 132.349 164.474 132.796 164.201C133.242 163.928 133.781 163.791 134.414 163.791C134.899 163.791 135.307 163.869 135.636 164.025C135.965 164.181 136.232 164.387 136.436 164.643C136.644 164.894 136.802 165.169 136.91 165.468C137.018 165.767 137.092 166.06 137.131 166.346C137.17 166.632 137.19 166.883 137.19 167.1V171H135.812ZM130.878 171V163.98H132.094V166.008H132.256V171H130.878ZM142.9 171C142.458 171.087 142.024 171.124 141.6 171.111C141.175 171.098 140.796 171.015 140.462 170.863C140.128 170.712 139.877 170.473 139.708 170.148C139.556 169.858 139.474 169.563 139.461 169.264C139.452 168.961 139.448 168.619 139.448 168.237V162.03H140.813V168.172C140.813 168.454 140.815 168.699 140.82 168.907C140.828 169.115 140.874 169.29 140.956 169.433C141.112 169.702 141.359 169.856 141.697 169.895C142.039 169.93 142.44 169.914 142.9 169.849V171ZM138.103 165.072V163.98H142.9V165.072H138.103ZM147.176 171.195C146.478 171.195 145.865 171.043 145.336 170.74C144.812 170.432 144.403 170.005 144.108 169.459C143.818 168.909 143.672 168.272 143.672 167.548C143.672 166.781 143.815 166.116 144.101 165.553C144.392 164.99 144.795 164.554 145.31 164.246C145.826 163.939 146.426 163.785 147.111 163.785C147.826 163.785 148.435 163.952 148.937 164.286C149.44 164.615 149.815 165.085 150.062 165.696C150.313 166.307 150.413 167.033 150.361 167.873H149.002V167.379C148.994 166.565 148.838 165.962 148.534 165.572C148.235 165.182 147.778 164.987 147.163 164.987C146.483 164.987 145.971 165.202 145.629 165.631C145.287 166.06 145.115 166.68 145.115 167.49C145.115 168.261 145.287 168.859 145.629 169.284C145.971 169.704 146.465 169.914 147.111 169.914C147.536 169.914 147.902 169.819 148.209 169.628C148.521 169.433 148.764 169.156 148.937 168.796L150.27 169.219C149.997 169.847 149.583 170.335 149.028 170.681C148.474 171.024 147.856 171.195 147.176 171.195ZM144.673 167.873V166.814H149.685V167.873H144.673Z"
                fill="#0075FF"
            />
            <path
                d="M94.4875 188.027C93.6375 188.027 92.8 187.69 92.25 187.052C91.7125 186.44 91.5 185.79 91.5 184.94V181.727C91.5 180.89 91.7125 180.215 92.275 179.59C92.8125 178.99 93.625 178.64 94.4875 178.652C95.325 178.64 96.1375 178.965 96.7 179.59C97.25 180.19 97.475 180.877 97.475 181.727V184.94C97.475 185.752 97.2625 186.44 96.7375 187.052C96.175 187.677 95.375 188.027 94.4875 188.027ZM94.4875 179.627C93.8125 179.615 93.2 179.977 92.85 180.515C92.625 180.865 92.525 181.265 92.525 181.727V184.94C92.525 185.377 92.6 185.802 92.85 186.165C93.2125 186.702 93.825 187.052 94.4875 187.052C95.1625 187.052 95.775 186.702 96.125 186.165C96.375 185.802 96.45 185.427 96.45 184.94V181.727C96.45 181.265 96.3625 180.902 96.1375 180.515C95.775 179.977 95.1625 179.615 94.4875 179.627ZM101.46 188.027C100.61 188.027 99.7727 187.69 99.2227 187.052C98.6852 186.44 98.4727 185.79 98.4727 184.94V181.727C98.4727 180.89 98.6852 180.215 99.2477 179.59C99.7852 178.99 100.598 178.64 101.46 178.652C102.298 178.64 103.11 178.965 103.673 179.59C104.223 180.19 104.448 180.877 104.448 181.727V184.94C104.448 185.752 104.235 186.44 103.71 187.052C103.148 187.677 102.348 188.027 101.46 188.027ZM101.46 179.627C100.785 179.615 100.173 179.977 99.8227 180.515C99.5977 180.865 99.4977 181.265 99.4977 181.727V184.94C99.4977 185.377 99.5727 185.802 99.8227 186.165C100.185 186.702 100.798 187.052 101.46 187.052C102.135 187.052 102.748 186.702 103.098 186.165C103.348 185.802 103.423 185.427 103.423 184.94V181.727C103.423 181.265 103.335 180.902 103.11 180.515C102.748 179.977 102.135 179.615 101.46 179.627ZM108.433 188.027C107.583 188.027 106.745 187.69 106.195 187.052C105.658 186.44 105.445 185.79 105.445 184.94V181.727C105.445 180.89 105.658 180.215 106.22 179.59C106.758 178.99 107.57 178.64 108.433 178.652C109.27 178.64 110.083 178.965 110.645 179.59C111.195 180.19 111.42 180.877 111.42 181.727V184.94C111.42 185.752 111.208 186.44 110.683 187.052C110.12 187.677 109.32 188.027 108.433 188.027ZM108.433 179.627C107.758 179.615 107.145 179.977 106.795 180.515C106.57 180.865 106.47 181.265 106.47 181.727V184.94C106.47 185.377 106.545 185.802 106.795 186.165C107.158 186.702 107.77 187.052 108.433 187.052C109.108 187.052 109.72 186.702 110.07 186.165C110.32 185.802 110.395 185.427 110.395 184.94V181.727C110.395 181.265 110.308 180.902 110.083 180.515C109.72 179.977 109.108 179.615 108.433 179.627ZM118.195 188.027C117.345 188.027 116.507 187.69 115.957 187.052C115.42 186.44 115.207 185.79 115.207 184.94V181.727C115.207 180.89 115.42 180.215 115.982 179.59C116.52 178.99 117.332 178.64 118.195 178.652C119.032 178.64 119.845 178.965 120.407 179.59C120.957 180.19 121.182 180.877 121.182 181.727V184.94C121.182 185.752 120.97 186.44 120.445 187.052C119.882 187.677 119.082 188.027 118.195 188.027ZM118.195 179.627C117.52 179.615 116.907 179.977 116.557 180.515C116.332 180.865 116.232 181.265 116.232 181.727V184.94C116.232 185.377 116.307 185.802 116.557 186.165C116.92 186.702 117.532 187.052 118.195 187.052C118.87 187.052 119.482 186.702 119.832 186.165C120.082 185.802 120.157 185.427 120.157 184.94V181.727C120.157 181.265 120.07 180.902 119.845 180.515C119.482 179.977 118.87 179.615 118.195 179.627ZM125.167 188.027C124.317 188.027 123.48 187.69 122.93 187.052C122.392 186.44 122.18 185.79 122.18 184.94V181.727C122.18 180.89 122.392 180.215 122.955 179.59C123.492 178.99 124.305 178.64 125.167 178.652C126.005 178.64 126.817 178.965 127.38 179.59C127.93 180.19 128.155 180.877 128.155 181.727V184.94C128.155 185.752 127.942 186.44 127.417 187.052C126.855 187.677 126.055 188.027 125.167 188.027ZM125.167 179.627C124.492 179.615 123.88 179.977 123.53 180.515C123.305 180.865 123.205 181.265 123.205 181.727V184.94C123.205 185.377 123.28 185.802 123.53 186.165C123.892 186.702 124.505 187.052 125.167 187.052C125.842 187.052 126.455 186.702 126.805 186.165C127.055 185.802 127.13 185.427 127.13 184.94V181.727C127.13 181.265 127.042 180.902 126.817 180.515C126.455 179.977 125.842 179.615 125.167 179.627ZM132.14 188.027C131.29 188.027 130.452 187.69 129.902 187.052C129.365 186.44 129.152 185.79 129.152 184.94V181.727C129.152 180.89 129.365 180.215 129.927 179.59C130.465 178.99 131.277 178.64 132.14 178.652C132.977 178.64 133.79 178.965 134.352 179.59C134.902 180.19 135.127 180.877 135.127 181.727V184.94C135.127 185.752 134.915 186.44 134.39 187.052C133.827 187.677 133.027 188.027 132.14 188.027ZM132.14 179.627C131.465 179.615 130.852 179.977 130.502 180.515C130.277 180.865 130.177 181.265 130.177 181.727V184.94C130.177 185.377 130.252 185.802 130.502 186.165C130.865 186.702 131.477 187.052 132.14 187.052C132.815 187.052 133.427 186.702 133.777 186.165C134.027 185.802 134.102 185.427 134.102 184.94V181.727C134.102 181.265 134.015 180.902 133.79 180.515C133.427 179.977 132.815 179.615 132.14 179.627ZM141.902 188.027C141.052 188.027 140.214 187.69 139.664 187.052C139.127 186.44 138.914 185.79 138.914 184.94V181.727C138.914 180.89 139.127 180.215 139.689 179.59C140.227 178.99 141.039 178.64 141.902 178.652C142.739 178.64 143.552 178.965 144.114 179.59C144.664 180.19 144.889 180.877 144.889 181.727V184.94C144.889 185.752 144.677 186.44 144.152 187.052C143.589 187.677 142.789 188.027 141.902 188.027ZM141.902 179.627C141.227 179.615 140.614 179.977 140.264 180.515C140.039 180.865 139.939 181.265 139.939 181.727V184.94C139.939 185.377 140.014 185.802 140.264 186.165C140.627 186.702 141.239 187.052 141.902 187.052C142.577 187.052 143.189 186.702 143.539 186.165C143.789 185.802 143.864 185.427 143.864 184.94V181.727C143.864 181.265 143.777 180.902 143.552 180.515C143.189 179.977 142.577 179.615 141.902 179.627ZM148.874 188.027C148.024 188.027 147.187 187.69 146.637 187.052C146.099 186.44 145.887 185.79 145.887 184.94V181.727C145.887 180.89 146.099 180.215 146.662 179.59C147.199 178.99 148.012 178.64 148.874 178.652C149.712 178.64 150.524 178.965 151.087 179.59C151.637 180.19 151.862 180.877 151.862 181.727V184.94C151.862 185.752 151.649 186.44 151.124 187.052C150.562 187.677 149.762 188.027 148.874 188.027ZM148.874 179.627C148.199 179.615 147.587 179.977 147.237 180.515C147.012 180.865 146.912 181.265 146.912 181.727V184.94C146.912 185.377 146.987 185.802 147.237 186.165C147.599 186.702 148.212 187.052 148.874 187.052C149.549 187.052 150.162 186.702 150.512 186.165C150.762 185.802 150.837 185.427 150.837 184.94V181.727C150.837 181.265 150.749 180.902 150.524 180.515C150.162 179.977 149.549 179.615 148.874 179.627ZM155.847 188.027C154.997 188.027 154.159 187.69 153.609 187.052C153.072 186.44 152.859 185.79 152.859 184.94V181.727C152.859 180.89 153.072 180.215 153.634 179.59C154.172 178.99 154.984 178.64 155.847 178.652C156.684 178.64 157.497 178.965 158.059 179.59C158.609 180.19 158.834 180.877 158.834 181.727V184.94C158.834 185.752 158.622 186.44 158.097 187.052C157.534 187.677 156.734 188.027 155.847 188.027ZM155.847 179.627C155.172 179.615 154.559 179.977 154.209 180.515C153.984 180.865 153.884 181.265 153.884 181.727V184.94C153.884 185.377 153.959 185.802 154.209 186.165C154.572 186.702 155.184 187.052 155.847 187.052C156.522 187.052 157.134 186.702 157.484 186.165C157.734 185.802 157.809 185.427 157.809 184.94V181.727C157.809 181.265 157.722 180.902 157.497 180.515C157.134 179.977 156.522 179.615 155.847 179.627Z"
                fill="#0075FF"
            />
            <defs>
                <filter
                    id="filter0_d_123_6662"
                    x="0"
                    y="0"
                    width="384.738"
                    height="453"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="27" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.2125 0 0 0 0 0.622 0 0 0 0 1 0 0 0 0.12 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_123_6662"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_123_6662"
                        result="shape"
                    />
                </filter>
                <pattern
                    id="pattern0"
                    patternContentUnits="objectBoundingBox"
                    width="1"
                    height="1">
                    <use
                        xlinkHref="#image0_123_6662"
                        transform="translate(0 -0.0122141) scale(0.00112613 0.00316182)"
                    />
                </pattern>
                <filter
                    id="filter1_i_123_6662"
                    x="66.9146"
                    y="115.495"
                    width="156.23"
                    height="120.23"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dx="40" dy="4" />
                    <feGaussianBlur stdDeviation="22" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                    />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.929143 0 0 0 0 0.929143 0 0 0 0 0.929143 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_123_6662"
                    />
                </filter>
            </defs>
        </svg>
    )
}

export default BollettaIllustration
